"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export default function FilterValue({
  value,
  disabled,
}: {
  value: string;
  disabled: boolean;
}) {
  const pathname = usePathname();

  return (
    <li key={value}>
      <Link
        aria-disabled={disabled}
        href={`${pathname}#${value}`}
        replace
        onClick={(e) => {
          e.preventDefault();
          document
            .getElementById(value)
            ?.scrollIntoView({ behavior: "smooth" });
        }}
        className="block px-4 aria-disabled:pointer-events-none aria-disabled:opacity-50 child:hover:border-b-black"
      >
        <span className="block border-y-[3px] border-transparent py-2">
          {value}
        </span>
      </Link>
    </li>
  );
}
